import {doc, setDoc} from "firebase/firestore";
import {fire} from "../../../fire";

export const guardarFechaAct = async (col) => {


    let dox = await setDoc(doc(fire, 'fechas', col), {fecha: new Date().getTime()})



}